
function subtractNumbers(numberA,numberB) {
return numberA - numberB;
}

export { subtractNumbers }